
export const basePadding = {
  paddingHorizontal: 20,
  paddingVertical: 20,
  base: 16,
}

export const baseMargin = {
  marginHorizontal: 20,
  marginVertical: 20,
  base: 16,
}

export const smallPadding = {
  paddingHorizontal: 10,
  paddingVertical: 10,
  base: 16,
}